import React from "react";

import Edit from "./Edit";
import Overview from "./Overview";
export const Privacy = () => {
  return (
    
      <Overview />
    
  );
};

export const EditPrivacy = () => {
  return (
    
      <Edit />
    
  );
};
